export enum LeaseRoleNames {
  LESSOR = 'LESSOR',
  LESSEE = 'LESSEE',
  GUARANTOR = 'GUARANTOR',
  DRAFTER = 'DRAFTER',
  SPECTATOR = 'SPECTATOR',
}
